module.exports = "# Esmeralda and Goober Closing Story\n\nYouTube: QXO9vRoYePU\n\n## Notes\nEsmeralda gives the Apprentices their third mission (3:09).\n"


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/sections/60_esClosingStory/level3_closing.md
// module id = 1862
// module chunks = 2